import { useId, useRef } from 'react';
import { TextInput } from '../../ui/components';

export default function ColorPicker({ label, value, onChange }) {
  const inputRef = useRef();
  const inputId = useId();

  return (
    <div className="adm-field">
      {label && <label className="adm-label" htmlFor={inputId}>{label}</label>}
      <div className="adm-color-row">
        <button
          type="button"
          className="adm-color-swatch ui-color-swatch"
          style={{ background: value }}
          onClick={() => inputRef.current.click()}
          aria-label={`Choose ${label || 'colour'}`}
        />
        <input
          id={inputId}
          type="color"
          ref={inputRef}
          value={value}
          onChange={e => onChange(e.target.value)}
          className="adm-color-native"
        />
        <TextInput
          type="text"
          className="adm-input adm-input--mono"
          value={value}
          onChange={e => onChange(e.target.value)}
          maxLength={7}
          spellCheck={false}
          aria-label={`${label || 'Colour'} hex value`}
        />
      </div>
    </div>
  );
}
